import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TextInput from '../../../common/inputs/text-input/TextInput';
import Button from '../../../common/button/Button';

import { ReactComponent as SignInGoogle } from '../../../../resources/buttons/sign-in-google.svg';
import { ReactComponent as SignInApple } from '../../../../resources/buttons/sign-in-apple.svg';
import { ReactComponent as GooglePlay } from '../../../../resources/icons/google_play_greyed_out.svg';
import { ReactComponent as AppStore } from '../../../../resources/icons/app_store_greyed_out.svg';
import { ReactComponent as AppGallery } from '../../../../resources/icons/appgallery_greyed_out.svg';

import './sign-up.scss';

const SignUp = ({ register, successfulReg, initialEmail }) => {
  const [email, setEmail] = useState(initialEmail ?? '');

  const navigate = useNavigate();

  const APPLE_LOGIN_LINK = process.env.REACT_APP_APPLE_LOGIN_LINK;
  const GOOGLE_LOGIN_LINK = process.env.REACT_APP_GOOGLE_LOGIN_LINK;

  const handleSignUpClick = () => {
    const initialPerson = {
      email,
    };
    register(initialPerson);
  };

  return (
    <section className="sign-up">
      {successfulReg ? (
        <>
          <p className="sign-up__success-heading">Thanks!</p>
          <p className="sign-up__success-message">
            Please check your inbox for confirmation email to activate your account.
          </p>
          <Button onClick={() => navigate('/')}>Return Home</Button>
        </>
      ) : (
        <>
          <button className="sign-up__provider-button" onClick={() => window.open(GOOGLE_LOGIN_LINK)}>
            <SignInGoogle data-testid="sign-in-with-google" />
          </button>
          <button className="sign-up__provider-button" onClick={() => window.open(APPLE_LOGIN_LINK)}>
            <SignInApple data-testid="sign-in-with-apple" />
          </button>

          <p>or use your email account</p>

          <div className="sign-up__form" data-testid="login-form">
            <TextInput
              name="email"
              placeholder="Email"
              value={email}
              onChange={({ target }) => setEmail(target.value)}
              type="email"
              disabled={!!initialEmail}
              auth
            />

            <div className="sign-up__button-container">
              <Button onClick={() => navigate('/')}>Back</Button>
              <Button onClick={handleSignUpClick} disabled={!email}>
                Sign Up
              </Button>
            </div>
          </div>
          <div className="sign-up__coming-soon">
            <p>Mobile app coming soon</p>
            <div className="sign-up__store-logos">
              <GooglePlay />
              <AppStore />
              <AppGallery />
            </div>
          </div>
        </>
      )}
    </section>
  );
};

SignUp.propTypes = {
  register: PropTypes.func.isRequired,
  successfulReg: PropTypes.bool.isRequired,
  initialEmail: PropTypes.string,
};

SignUp.defaultProps = {
  initialEmail: undefined,
};

export default SignUp;
